import React from 'react';
import CheckBox from '../Shared/CheckBox';
import { SingleFilters } from '../types';


const SingleSelect = (props: SingleFilters) => {
  const { filterData, activeFilters, handleFilterChange } = props;
  const { data = [] } = filterData || {};
  return (
    <>
      {
        data.map(item => {
          const isSelected = (activeFilters?.id == item.id);
          return ( <CheckBox type="radio" key={`radio_${item.id}`} data={item} isSelected={isSelected} handleFilterChange={handleFilterChange} />);
          })
      }
    </>
  );
};

export default SingleSelect;
